// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2xwxe","clinicsSelect":"TableHeading_clinicsSelect__2aeGU"};